import type { ModuleBuildSettings, PlayerBuild, PlayerBuildSettings } from '@webapp2/shared/model'
import { adminState } from '../state'
import { ensureById } from './admin-entity-service'

export function ensurePlayerBuilds(ids: string[]) {
  return ensureById<PlayerBuild>('PlayerBuild', adminState.playerBuilds, ids, x => (adminState.playerBuilds = x))
}

export function ensureModuleBuildSettings(ids: string[]) {
  return ensureById<ModuleBuildSettings>(
    'ModuleBuildSettings',
    adminState.moduleBuildSettings,
    ids,
    x => (adminState.moduleBuildSettings = x)
  )
}

export function ensurePlayerBuildSettings(ids: string[]) {
  return ensureById<PlayerBuildSettings>(
    'PlayerBuildSettings',
    adminState.playerBuildSettings,
    ids,
    x => (adminState.playerBuildSettings = x)
  )
}
